<script setup lang="ts">
import SharedLicenseModal from './shared/OpenSourceLicenseModal.vue';
import { openSourceLicenses } from '../openSourceLicenses';
import type { OpenSourceLicense } from './shared/openSourceLicense';

withDefaults(defineProps<{ open: boolean; appName?: string; licenses?: OpenSourceLicense[] }>(), { appName: 'fuqiAccount' });
defineEmits<{ close: [] }>();
</script>

<template>
  <SharedLicenseModal :open="open" :app-name="appName" :licenses="licenses ?? openSourceLicenses" teleport-class="fuqi-account-root" @close="$emit('close')" />
</template>
